import { z } from 'zod';
import { userIdSchema } from './user.js';
export const interviewStateSchema = z.enum([
    'scheduled',
    'lobby_open',
    'in_progress',
    'completed',
    'cancelled',
]);
/** A job profile pins the pre-provisioned web VSCode environment used for the interview. */
export const jobProfileSchema = z.object({
    id: z.uuid(),
    name: z.string().min(1),
    vscodeUrl: z.url(),
});
export const interviewSchema = z.object({
    id: z.uuid(),
    candidateId: userIdSchema,
    interviewerIds: z.array(userIdSchema).min(1).max(4),
    jobProfile: jobProfileSchema,
    state: interviewStateSchema,
    roomName: z.string().min(1),
    scheduledAt: z.iso.datetime(),
    // Absent until the session actually starts/ends; the room stays joinable past the
    // scheduled slot, so actual times are what retention and the 72h window key off.
    startedAt: z.iso.datetime().nullable(),
    endedAt: z.iso.datetime().nullable(),
});
//# sourceMappingURL=interview.js.map